import React, {useState} from "react";
import {Link} from "react-router-dom";
import {Button, Dropdown, Space} from "antd";
import {BellOutlined, DownOutlined} from "@ant-design/icons";


import DrawerMB from "./menuMB/Drawer";
import config from '@/config'
import {NavItems} from "@/components/NavItems";

const Navbar = () => {
    const items = [
        {
            key: "1",
            label: (
                <Link
                    to={config.routes.registerCandidate} // Sử dụng to thay vì href
                    className="relative group hover:text-primary transition duration-300"
                >
                    Ứng viên
                    <span
                        className="absolute bottom-[-4px] left-0 w-0 h-[2px] bg-primary transition-all duration-300 group-hover:w-full"></span>
                </Link>
            ),
        },
        {
            key: "22",
            label: (
                <Link
                    to={config.routes.registerEmployer} // Sử dụng to thay vì href
                    className="relative group hover:text-primary transition duration-300"
                >
                    Nhà tuyển dụng
                    <span
                        className="absolute bottom-[-4px] left-0 w-0 h-[2px] bg-primary transition-all duration-300 group-hover:w-full"></span>
                </Link>
            ),
        },
    ];
    const navitems = [
        {
            title: "trang chủ",
            src: config.routes.home,
        },
        {
            title: "việc làm",
            src: config.routes.job,
        },
        {
            title: "công ty",
            src: config.routes.company,
        },
        {
            title: "khu công nghiệp",
            src: config.routes.IndustrialPack,
        },
        {
            title: "cv ứng tuyển",
            src: config.routes.cv,
        },
        {
            title: "tin tức",
            src: config.routes.news,
        },
    ]
    const loggedInItems = [
        {
            title: "Tạo hồ sơ",
            src: config.routes.resume,
        },
        {
            title: "Tạo không gian tuyển dụng",
            src: config.routes.createApplyLists,
        },
        {
            title: "Thông tin cá nhân",
            src: config.routes.profile,
        },
        {
            title: "Đăng xuất",
            src: "/logout",
        },
    ]
    const [notifications, setNotifications] = useState([
        "Bạn đã đăng ký thành công vị trí nhân viên kinh doanh tại Công ty ABC",
        "Bạn đã được mời phỏng vấn tại Công ty XYZ",
        "Hồ sơ của bạn đã được duyệt",
        "Công ty ABC vừa cập nhật tin tuyển dụng mới",
    ]);

    // Xóa tất cả thông báo
    const clearNotifications = () => {
        setNotifications([]);
    };

    return (
        // <nav className="px-4 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white shadow-lg sticky top-0 z-50">
        // <nav className="px-4 bg-gradient-to-r from-cyan-800 to-cyan-400 text-white shadow-lg sticky top-0 z-50">
        <nav className="px-4 bg-white text-black text-md shadow-lg sticky top-0 z-50">
            <div className="container mx-auto px-4 flex justify-between items-center uppercase py-4">
                {/* Logo */}
                <div className="text-2xl">
                    <Link to={config.routes.home}>
                        <img src="/img/logo_TinViet.jpg" alt="logo" className="w-36 h-auto"/>
                    </Link>
                </div>

                {/* Menu Items */}
                <div className="hidden lg:flex space-x-8">
                    {navitems.map((item, index) => (
                        <NavItems key={index} title={item.title} src={item.src}/>
                    ))}
                </div>
                {/* Login and Register Buttons */}
                    <div className="space-x-4 hidden lg:block">
                        <Link
                            to={config.routes.login}
                            className="relative group text-sm font-medium mr-4 hover:text-primary transition duration-300"
                        >
                            Đăng nhập
                            <span
                                className="absolute bottom-[-4px] left-0 w-0 h-[2px] bg-primary transition-all duration-300 group-hover:w-full"></span>
                        </Link>

                        {/* Dropdown for Đăng ký */}
                        <Dropdown
                            menu={{
                                items,
                            }}
                        >
                <span
                    // onClick={(e) => e.preventDefault()}
                    className="relative cursor-pointer group text-sm font-medium mr-4 hover:text-primary transition duration-300"
                >
                  <Space>
                    Đăng ký
                    <DownOutlined/>
                  </Space>
                  <span
                      className="absolute bottom-[-4px] left-0 w-0 h-[2px] bg-primary transition-all duration-300 group-hover:w-full"></span>
                </span>
                        </Dropdown>
                    </div>
            {/*    <div className={'flex gap-4'}>*/}
            {/*        <Dropdown className={"lg:block hidden"} overlay={(*/}
            {/*            <div className={'bg-white shadow-lg '}>*/}
            {/*                {loggedInItems.map((item, index) => (*/}
            {/*                    <Link key={index} to={item.src}*/}
            {/*                          className={'block px-4 py-2 hover:bg-gray-100'}>{item.title}</Link>*/}
            {/*                ))}*/}
            {/*            </div>*/}
            {/*        )}>*/}
            {/*            <p className={'cursor-pointer'}>Chào mừng, <span*/}
            {/*                className={"text-primary hover:text-primary-hover"}>Nguyễn văn A</span></p>*/}
            {/*        </Dropdown>*/}
            {/*        <Dropdown*/}
            {/*            overlay={*/}
            {/*                <div className="bg-white shadow-lg w-64 max-h-80 overflow-hidden rounded-md">*/}
            {/*                    <div*/}
            {/*                        className="max-h-64  overflow-y-auto p-4 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">*/}
            {/*                        {notifications.length > 0 ? (*/}
            {/*                            notifications.map((text, index) => (*/}
            {/*                                <div key={index}*/}
            {/*                                     className="flex items-start hover:bg-green-100 gap-3 p-2 border-b last:border-none">*/}
            {/*                                    <img src="/img/icon_cpn.png" alt="notify"*/}
            {/*                                         className="w-8 h-8 object-contain"/>*/}
            {/*                                    <div className="flex flex-col">*/}
            {/*                                        <p className="text-sm leading-tight">{text}</p>*/}
            {/*                                        <p className="text-xs text-gray-400">1 giờ trước</p>*/}
            {/*                                    </div>*/}
            {/*                                </div>*/}
            {/*                            ))*/}
            {/*                        ) : (*/}
            {/*                            <div className="text-center text-gray-500 py-4">Không có thông báo nào</div>*/}
            {/*                        )}*/}
            {/*                    </div>*/}
            {/*                    /!* Footer sticky *!/*/}
            {/*                    {notifications.length > 0 && (*/}
            {/*                        <div className="sticky bottom-0 bg-white p-2 border-t text-center">*/}
            {/*                            <Button type="text" danger onClick={clearNotifications}>*/}
            {/*                                Xóa tất cả thông báo*/}
            {/*                            </Button>*/}
            {/*                        </div>*/}
            {/*                    )}*/}
            {/*                </div>*/}
            {/*            }*/}
            {/*            trigger={["click"]}*/}
            {/*        >*/}
            {/*            <BellOutlined className="text-xl cursor-pointer"/>*/}
            {/*        </Dropdown>*/}
            {/*</div>*/}

            {/* DrawerMB for Mobile */}
            <div className="block lg:hidden">
                <DrawerMB/>
            </div>
        </div>
</nav>
)
    ;
};

export default Navbar;
